<template>
  <div class="wrap">
    <div class="bannerimg">
      <img src="@/assets/other/recruitment.jpg" alt="" style="width: 100%" />
    </div>
    <!-- <div class="tab">
      <div class="item-box">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="['item', currentIndex == index ? 'active' : '']"
          @click="changeTab(index)"
        >
          {{ item }}
        </div>
      </div>
    </div> -->
    <!-- <div class="pagew content" v-if="currentIndex == 1"> -->
    <Nav title="人才招聘" />
    <div class="pagew content" >
      <div class="title">招聘岗位:材料研发工程师</div>
      <div class="bottom-content">
        <div class="item">
          <div class="info">岗位职责:</div>
          <div class="name">
            （1）能熟练完成多步有机化学反应，根据要求如期完成规定的实验任务
            <br />
            （2）清晰完整地完成实验记录，整理实验结果，并清晰规范记录实验过程;分析测试图谱;确保实验报告真实，详细，可靠；<br />
            （3）负责实验设备日常维护，以及安全卫生的保持工作。完成专利初稿撰写。
          </div>
        </div>
        <div class="item">
          <div class="info1">岗位要求:</div>
          <div class="name">
            （1）有机化学等相关专业，本科及以上学历；<br />
            （2）熟悉常见有机反应及相关产物分离纯化技术，能进行反应
            放大工艺；<br />
            （3）能熟练使用常用文献检索工具比如Scifinder；<br />
            （4）熟悉现代分析仪器比如NMR， GCMS，LCMS等；<br />
            （5）具有良好的实验安全卫生习惯和强烈的责任意识，能爱护实验室及设备。
          </div>
        </div>
        <div class="item">
          <div class="info1">
            薪资待遇:<span style="font-weight:normal">待遇面议</span>
          </div>
        </div>
      </div>
    </div>

    <Footer class="workspace-footer" :show="true" />
  </div>
</template>

<script>
import Nav from "../../components/Nav/Nav.vue";
export default {
  name: "cooperation",
  components: { Nav },
  data() {
    return {
      list: ["公司简介", "招贤纳士"],
      currentIndex: 1
    };
  },
  methods: {
    changeTab(index) {
      this.currentIndex = index;
      if (this.currentIndex == 0) {
        this.$router.push({ name: "workspace" });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.wrap {
  width: 100%;

  .bannerimg {
    margin-top: 82px;
  }
  .tab {
    width: 100%;
    height: 50px;
    background-color: #f4f9ff;
    .item-box {
      display: flex;
      width: 1200px;
      margin: 0 auto;
      .item {
        width: 150px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-weight: bold;
      }
      .active {
        background-color: #5197d5;
        color: #fff;
      }
    }
  }

  .content {
    margin-top: 20px;
    text-align: left;
    .title {
      padding: 5px 0 5px 20px;
      font-size: 20px;
      font-weight: bold;
      background-color: #5197d5;
      color: #fff;
    }

    .bottom-content {
      padding: 20px;
      background-color: #f4f9ff;
      .item {
        // margin-top: 10px;
        .info {
          font-size: 16px;
          font-weight: bold;
        }
        .info1 {
          font-size: 16px;
          font-weight: bold;
          margin-top: 30px;
        }
        .name {
          margin-top: 15px;
          line-height: 30px;
          text-align: left;
          font-size: 16px;

        }
      }
    }
  }
}
</style>
<style lang="scss">
.workspace-footer.footerbox {
  margin-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/view/Match/recruitment.vue